import BaseResourceService from "./BaseResourceService";
import axios from "@/plugins/axios";

export default class InvestmentsService extends BaseResourceService {
  static get baseURL() {
    return this.apiUrl + "investments";
  }

  static getAvailablePayments(attributes) {
    return axios
      .post(this.baseURL + "/available-payments", attributes)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        this._shouldLogout(error);
        throw error;
      });
  }

  static prepare(attributes) {
    return axios
      .post(this.baseURL + "/prepare", attributes)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        this._shouldLogout(error);
        throw error;
      });
  }

  static prepareTransaction(attributes) {
    return axios
      .post(this.baseURL + "/prepare-transaction", attributes)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        this._shouldLogout(error);
        throw error;
      });
  }

  static complete(attributes) {
    return axios
      .post(this.baseURL + "/complete", attributes)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        this._shouldLogout(error);
        throw error;
      });
  }

  static markAsPaid(attributes) {
    return axios
        .post(this.baseURL + "/mark-as-paid", attributes)
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          this._shouldLogout(error);
          throw error;
        });
  }

  static transferNFT(attributes) {
    return axios
        .post(this.baseURL + "/transfer-nft", attributes)
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          this._shouldLogout(error);
          throw error;
        });
  }

  static buyTokens(attributes) {
    return axios
        .post(this.baseURL + "/buy-tokens", attributes)
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          this._shouldLogout(error);
          throw error;
        });
  }

}
